import { css } from '@emotion/css';

export const buttonStyles = css`
  &:active {
    .button-text {
      color: var(--text-primary);
    }
    .MuiButton-startIcon svg {
      fill: var(--icon-primary);
    }
  }
`;

export const BUTTON_CONFIG = {
  long: 'w-full p-16 pe-20',
  short: 'self-start p-12 pe-16',
};

export const TITLE_CONTAINER_CONFIG = {
  long: 'ms-16',
  short: 'ms-12',
};

export const TITLE_CONFIG = {
  long: 'mb-4',
  short: '',
};

export const TITLE_VARIANT = {
  long: 'mb-4 body-short-01',
  short: 'body-short-02',
};

export const SUB_TITLE_VARIANT = {
  long: 'body-short-02',
  short: 'body-short-03',
};

export const ICON_CONFIG = {
  long: 'w-20 h-20',
  short: 'w-16 h-16',
};

export const ICON_CONTAINER_CONFIG = {
  user: {
    long: 'w-48 h-48 rounded-full',
    short: 'w-38 h-38 rounded-full',
  },
  content: {
    long: 'w-48 h-48 rounded-8',
    short: 'w-38 h-38 rounded-8',
  },
};
